import React, {useEffect} from 'react'

function Footer({ className }) {
    useEffect(() => {
        // Function to handle footer padding
        const setFooterPadding = () => {
            if (window.matchMedia('(min-width: 991px)').matches) {
              const footerHeight = document.getElementById("rts-footer")?.offsetHeight || 0;
          
              // Set a max height if necessary to prevent the padding from being too large
              const maxFooterHeight = 500; // Example: Maximum padding value (adjust as needed)
          
              // Apply padding to the wrapper, capping the footer height if necessary
              const finalPadding = Math.min(footerHeight, maxFooterHeight);
              
              document.querySelector(".rts-wrapper")?.style.setProperty('padding-bottom', `${finalPadding}px`);
            }
          };
    
        // Function to handle sticky footer logic on scroll
        const handleScroll = () => {
          if (window.matchMedia('(min-width: 991px)').matches) {
            const footerHeight = document.querySelector(".footer-sticky")?.offsetHeight || 0;
            const dimHeight = document.querySelector(".rts-footer-area")?.offsetHeight || 0;
            const scrollHeight = document.documentElement.scrollHeight;
            const scrollPosition = window.innerHeight + window.scrollY;
    
            if ((scrollHeight - scrollPosition) / scrollHeight === 0) {
              // When scrolling to the bottom
              document.querySelector(".rts-footer-area")?.classList.remove("dim-fixed");
              document.querySelector(".rts-footer-area")?.classList.add("dim-static");
              document.querySelector(".rts-footer-area")?.style.setProperty('bottom', `${footerHeight}px`);
            } else {
              document.querySelector(".rts-footer-area")?.classList.remove("dim-static");
              document.querySelector(".rts-footer-area")?.classList.add("dim-fixed");
              document.querySelector(".rts-footer-area")?.style.setProperty('bottom', '0');
            }
          }
        };
    
        // Set initial footer padding
        setFooterPadding();
    
        // Add scroll event listener
        window.addEventListener('scroll', handleScroll);
    
        // Cleanup on unmount
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, []);
    return (
        <>
            {/* Footer area End */}
            <section id="rts-footer" className={`rts-footer-area rts-section-gapTop ${className}`}>
                <div className="container">
                    <div className="footer-inner rts-section-gapTop">
                        <div className="footer-left-area">
                            <a href="#home" className="logo" aria-label="Go to Home">
                                <img src="assets/images/logo/logo-w.svg" alt="" />
                            </a>
                            <p className="desc">
                                we’re redefining the crypto space with a unique blend of innovation,
                                community-driven initiatives, and meme-powered fun.
                            </p>
                            <div className="social-area">
                                <div className="social-wrapper">
                                    <a href="#">
                                        <img
                                            src="assets/images/icon/01.svg"
                                            aria-label="discord"
                                            alt=""
                                        />
                                    </a>
                                </div>
                                <div className="social-wrapper">
                                    <a href="#">
                                        <img
                                            src="assets/images/icon/02.svg"
                                            aria-label="telegram"
                                            alt=""
                                        />
                                    </a>
                                </div>
                                <div className="social-wrapper">
                                    <a href="#">
                                        <img src="assets/images/icon/03.svg" aria-label="X" alt="" />
                                    </a>
                                </div>
                                <div className="social-wrapper">
                                    <a href="#">
                                        <img
                                            src="assets/images/icon/04.svg"
                                            aria-label="instagram"
                                            alt=""
                                        />
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="footer-single-wrapper">
                            <span className="heading-title">Quick Links</span>
                            <ul>
                                <li>
                                    <a href="#home">Home</a>
                                </li>
                                <li>
                                    <a href="#about">About CoinCraze</a>
                                </li>
                                <li>
                                    <a href="#token">Buy Token</a>
                                </li>
                                <li>
                                    <a href="#roadmap">Roadmap</a>
                                </li>
                                <li>
                                    <a href="#contact">Contact Us</a>
                                </li>
                            </ul>
                        </div>
                        <div className="footer-newsletter-area">
                            <span className="heading-title">Newsletter Signup</span>
                            <p className="desc">
                                Want exclusive updates? Sign up for our newsletter and never miss a
                                beat!
                            </p>
                            <form action="#">
                                <div className="form-group with-after2">
                                    <input
                                        id="emailn"
                                        name="email"
                                        placeholder="Enter Your Email Address"
                                        type="email"
                                        required=""
                                    />
                                </div>
                                <div className="button with-after2">
                                    <button className="rts-btn btn-primary bg-white" type="submit">
                                        Subscribe Now
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="copyright-area text-center">
                        <p>Copyright © CoinCraze. All rights received 2024</p>
                    </div>
                </div>
            </section>
            {/* Footer area End*/}
        </>

    )
}

export default Footer